export {
  AI_BASE_SYSTEM_PROMPT,
  AI_PROMPT_CATALOG,
  AI_PROMPT_TEMPLATE_ALIASES,
  AI_PROMPT_TEMPLATES,
  AI_SYSTEM_PROMPTS,
  getPromptDefinition,
  getPromptTemplate,
  getSystemPromptForPurpose
} from './aiPrompts.js'

// Returns only enabled providers
export function getEnabledProviders() {
  return AI_PROVIDERS.filter((p) => p.enabled)
}
// aiConfig.js
// Central config for AI providers, models, and purposes

export const AI_PROVIDERS = [
  {
    id: 'openrouter',
    name: 'OpenRouter',
    isDefault: true,
    // Prefer OpenRouter for text by default
    isDefaultTextProvider: true,
    enabled: true,
    models: [
      // --- OpenAI family (text output)
      {
        id: 'openai/gpt-4o-mini',
        name: 'OpenAI GPT-4o Mini',
        enabled: true,
        inputModalities: { text: true, image: true, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      // --- Free tier defaults (text output)
      {
        id: 'arcee-ai/trinity-large-preview:free',
        name: 'Arcee Trinity Large (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false, file: false },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: { maxFiles: 0 }
      },
      {
        id: 'arcee-ai/trinity-mini:free',
        name: 'Arcee Trinity Mini (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false, file: false },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: { maxFiles: 0 }
      },
      {
        id: 'stepfun/step-3.5-flash:free',
        name: 'StepFun Step 3.5 Flash (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false, file: false },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: { maxFiles: 0 }
      },
      {
        id: 'nvidia/nemotron-3-nano-30b-a3b:free',
        name: 'NVIDIA Nemotron 3 Nano 30B A3B (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false, file: false },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: { maxFiles: 0 }
      },
      {
        id: 'openai/gpt-4o',
        name: 'OpenAI GPT-4o',
        enabled: true,
        inputModalities: { text: true, image: true, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'openai/gpt-4',
        name: 'OpenAI GPT-4',
        enabled: true,
        inputModalities: { text: true, image: false, audio: false, video: false, file: false },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 0,
          maxFileSizeMB: 0,
          maxTotalFileSizeMB: 0,
          allowedExtensions: []
        }
      },
      {
        id: 'openai/gpt-4.1',
        name: 'OpenAI GPT-4.1',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-4.1-mini',
        name: 'OpenAI GPT-4.1 Mini',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-4.1-nano',
        name: 'OpenAI GPT-4.1 Nano',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-5.2',
        name: 'OpenAI GPT-5.2',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-5.2-chat',
        name: 'OpenAI GPT-5.2 Chat',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-5-mini',
        name: 'OpenAI GPT-5 Mini',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-5-nano',
        name: 'OpenAI GPT-5 Nano',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-3.5-turbo',
        name: 'OpenAI GPT-3.5 Turbo',
        enabled: true,
        inputModalities: { text: true, image: false, audio: false, video: false, file: false },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 0,
          maxFileSizeMB: 0,
          maxTotalFileSizeMB: 0,
          allowedExtensions: []
        }
      },
      // --- Google Gemini (text output unless noted)
      {
        id: 'google/gemini-pro',
        name: 'Google Gemini Pro',
        enabled: false,
        inputModalities: { text: true, image: false, audio: false, video: false, file: false },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 0,
          maxFileSizeMB: 0,
          maxTotalFileSizeMB: 0,
          allowedExtensions: []
        }
      },
      {
        id: 'google/gemini-1.5-pro',
        name: 'Google Gemini 1.5 Pro',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'google/gemini-3-pro-preview',
        name: 'Google Gemini 3 Pro Preview',
        enabled: true,
        inputModalities: { text: true, image: true, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'google/gemini-3.1-pro-preview',
        name: 'Google Gemini 3.1 Pro Preview',
        enabled: true,
        inputModalities: { text: true, image: true, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'google/gemini-3-flash-preview',
        name: 'Google Gemini 3 Flash Preview',
        enabled: true,
        inputModalities: { text: true, image: true, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'google/gemini-3.1-flash-lite-preview',
        name: 'Google Gemini 3.1 Flash Lite Preview',
        enabled: true,
        inputModalities: { text: true, image: true, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      // --- DeepSeek (text output)
      {
        id: 'deepseek/deepseek-chat',
        name: 'DeepSeek Chat',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'deepseek/deepseek-r1',
        name: 'DeepSeek R1',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      // --- Image output (OpenRouter)
      {
        id: 'google/gemini-2.5-flash-image',
        name: 'Google Gemini 2.5 Flash Image',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false },
        outputModalities: { text: true, image: true, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: ['image/png', 'image/jpeg', 'image/webp', 'image/gif']
        }
      },
      {
        id: 'mistralai/pixtral-12b',
        name: 'Mistral: Pixtral 12B',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: ['image/png', 'image/jpeg', 'image/webp', 'image/gif']
        }
      },
      {
        id: 'mistralai/pixtral-large-2411',
        name: 'Mistral: Pixtral Large 2411',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: ['image/png', 'image/jpeg', 'image/webp', 'image/gif']
        }
      },

      // --- Free Models (text output by default)
      //cognitivecomputations/dolphin-mistral-24b-venice-edition:free

      {
        id: 'cognitivecomputations/dolphin-mistral-24b-venice-edition:free',
        name: 'Venice: Uncensored (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'meituan/longcat-flash-chat:free',
        name: 'Meituan: LongCat Flash Chat (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'alibaba/tongyi-deepresearch-30b-a3b:free',
        name: 'Tongyi DeepResearch 30B A3B (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'x-ai/grok-4-fast',
        name: 'xAI Grok 4 Fast',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'nvidia/nemotron-nano-9b-v2:free',
        name: 'NVIDIA Nemotron Nano 9B V2 (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'openai/gpt-oss-120b:free',
        name: 'OpenAI gpt-oss-120b (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'openai/gpt-oss-20b:free',
        name: 'OpenAI gpt-oss-20b (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'z-ai/glm-4.5-air:free',
        name: 'Z.AI GLM 4.5 Air (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'qwen/qwen3-coder:free',
        name: 'Qwen3 Coder 480B A35B (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'moonshotai/kimi-k2:free',
        name: 'MoonshotAI Kimi K2 0711 (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'moonshotai/kimi-vl-a3b-thinking:free',
        name: 'MoonshotAI Kimi VL A3B Thinking (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'cognitivecomputations/dolphin-mistral-24b-venice-edition:free',
        name: 'Venice: Uncensored (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'google/gemma-3n-e2b-it:free',
        name: 'Google Gemma 3n 2B (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'tencent/hunyuan-a13b-instruct:free',
        name: 'Tencent Hunyuan A13B Instruct (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'tngtech/deepseek-r1t2-chimera:free',
        name: 'TNG DeepSeek R1T2 Chimera (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'mistralai/mistral-small-3.2-24b-instruct:free',
        name: 'Mistral Small 3.2 24B (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'moonshotai/kimi-dev-72b:free',
        name: 'MoonshotAI Kimi Dev 72B (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'deepseek/deepseek-r1-0528-qwen3-8b:free',
        name: 'Deepseek R1 0528 Qwen3 8B (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'deepseek/deepseek-r1-0528:free',
        name: 'DeepSeek R1 0528 (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'deepseek/deepseek-chat-v3-0324:free',
        name: 'DeepSeek Chat v3 0324 (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'deepseek/deepseek-chat-v3.1',
        name: 'DeepSeek Chat v3.1',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'mistralai/devstral-small-2505:free',
        name: 'Mistral Devstral Small 2505 (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'google/gemma-3n-e4b-it:free',
        name: 'Google Gemma 3n 4B (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'meta-llama/llama-3.3-8b-instruct:free',
        name: 'Meta Llama 3.3 8B Instruct (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'qwen/qwen3-4b:free',
        name: 'Qwen3 4B (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'qwen/qwen3-30b-a3b',
        name: 'Qwen3 30B A3B',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'qwen/qwen3-8b',
        name: 'Qwen3 8B',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'qwen/qwen3-14b',
        name: 'Qwen3 14B',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'qwen/qwen3-235b-a22b',
        name: 'Qwen3 235B A22B',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'tngtech/deepseek-r1t-chimera:free',
        name: 'TNG DeepSeek R1T Chimera (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'microsoft/mai-ds-r1:free',
        name: 'Microsoft MAI DS R1 (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'shisa-ai/shisa-v2-llama3.3-70b:free',
        name: 'Shisa AI Shisa V2 Llama 3.3 70B (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'arliai/qwq-32b-arliai-rpr-v1:free',
        name: 'ArliAI QwQ 32B RpR v1 (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'agentica-org/deepcoder-14b-preview:free',
        name: 'Agentica Deepcoder 14B Preview (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'meta-llama/llama-4-maverick',
        name: 'Meta Llama 4 Maverick',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'meta-llama/llama-4-scout',
        name: 'Meta Llama 4 Scout',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },

      {
        id: 'mistralai/mistral-small-3.1-24b-instruct:free',
        name: 'Mistral Small 3.1 24B (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'google/gemma-3-4b-it:free',
        name: 'Google Gemma 3 4B (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'google/gemma-3-12b-it:free',
        name: 'Google Gemma 3 12B (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'google/gemma-3-27b-it:free',
        name: 'Google Gemma 3 27B (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'qwen/qwen2.5-vl-32b-instruct',
        name: 'Qwen2.5 VL 32B',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'nousresearch/deephermes-3-llama-3-8b-preview:free',
        name: 'Nous DeepHermes 3 Llama 3 8B Preview (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'cognitivecomputations/dolphin3.0-r1-mistral-24b:free',
        name: 'Dolphin3.0 R1 Mistral 24B (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'cognitivecomputations/dolphin3.0-mistral-24b:free',
        name: 'Dolphin3.0 Mistral 24B (free)',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'mistralai/mistral-small-24b-instruct-2501',
        name: 'Mistral Small 3',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'google/gemini-2.0-flash-lite:free',
        name: 'Gemini 2.0 Flash Lite 001',
        enabled: false,
        free: true,
        inputModalities: { text: true, image: false, audio: true, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg',
            'text/plain'
          ]
        }
      },
      {
        id: 'meta-llama/llama-3.3-70b-instruct:free',
        name: 'Meta Llama 3.3 70B Instruct (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'qwen/qwen-2.5-coder-32b-instruct',
        name: 'Qwen2.5 Coder 32B Instruct',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'meta-llama/llama-3.2-3b-instruct:free',
        name: 'Meta Llama 3.2 3B Instruct (free)',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'qwen/qwen-2.5-72b-instruct',
        name: 'Qwen2.5 72B Instruct',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'meta-llama/llama-3.1-405b-instruct',
        name: 'Meta Llama 3.1 405B Instruct',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'mistralai/mistral-nemo',
        name: 'Mistral Nemo',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'google/gemma-2-9b-it',
        name: 'Google Gemma 2 9B',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },
      {
        id: 'mistralai/mistral-7b-instruct-v0.1',
        name: 'Mistral 7B Instruct',
        enabled: true,
        free: false,
        inputModalities: { text: true, image: false, audio: false, video: false },
        outputModalities: { text: true, image: false, audio: false, video: false }
      },

      // --- Additional multimodal text models (image input)
      {
        id: 'yi-vision/yi-34b-vision',
        name: 'Yi Vision 34B',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'yi-vision/yi-9b-vision',
        name: 'Yi Vision 9B',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'anthropic/claude-sonnet-4',
        name: 'Claude Sonnet 4',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'anthropic/claude-3-haiku',
        name: 'Claude 3 Haiku',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'anthropic/claude-opus-4',
        name: 'Claude Opus 4',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'anthropic/claude-3.5-sonnet',
        name: 'Claude 3.5 Sonnet',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'llava/llava-yi-34b',
        name: 'LLaVA Yi 34B',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'llava/llava-phi-3',
        name: 'LLaVA Phi-3',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'llava/llava-v1.6-34b',
        name: 'LLaVA v1.6 34B',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'firellava/firellava-13b',
        name: 'FireLLaVA 13B',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'hermes/hermes-2-vision',
        name: 'Hermes 2 Vision',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-4-vision-preview',
        name: 'GPT-4 Vision Preview',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'google/gemini-2.5-flash-text-preview',
        name: 'Gemini 2.5 Flash Text (preview)',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },

      // --- Audio-supporting Gemini (text output)
      {
        id: 'google/gemini-2.5-flash-lite',
        name: 'Gemini 2.5 Flash Lite',
        enabled: true,
        inputModalities: { text: true, image: false, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'google/gemini-2.5-flash-lite-preview-09-2025',
        name: 'Gemini 2.5 Flash Lite Preview 09-2025',
        enabled: true,
        inputModalities: { text: true, image: false, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'google/gemini-2.5-flash',
        name: 'Gemini 2.5 Flash',
        enabled: true,
        inputModalities: { text: true, image: false, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'google/gemini-2.5-pro',
        name: 'Gemini 2.5 Pro',
        enabled: true,
        inputModalities: { text: true, image: false, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'google/gemini-2.5-pro-preview-05-06',
        name: 'Gemini 2.5 Pro Preview 05-06',
        enabled: true,
        inputModalities: { text: true, image: false, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'google/gemini-2.0-flash-lite-001',
        name: 'Gemini 2.0 Flash Lite 001',
        enabled: true,
        inputModalities: { text: true, image: false, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg',
            'text/plain'
          ]
        }
      },
      {
        id: 'google/gemini-2.0-flash-001',
        name: 'Gemini 2.0 Flash 001',
        enabled: true,
        inputModalities: { text: true, image: false, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg',
            'text/plain'
          ]
        }
      }
    ]
  },
  {
    id: 'deepseek',
    name: 'DeepSeek',
    isDefault: false,
    enabled: true,
    models: [
      {
        id: 'deepseek-chat',
        name: 'DeepSeek Chat (Non-thinking Mode)',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'deepseek-reasoner',
        name: 'DeepSeek Reasoner (Thinking Mode)',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      }
    ]
  },
  {
    id: 'openai',
    name: 'OpenAI',
    isDefault: false,
    // Prefer OpenAI for image by default
    isDefaultImageProvider: true,
    enabled: true,
    models: [
      {
        id: 'openai/gpt-4o-mini',
        name: 'OpenAI GPT-4o Mini',
        enabled: true,
        inputModalities: { text: true, image: true, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'openai/gpt-4o',
        name: 'OpenAI GPT-4o',
        enabled: true,
        inputModalities: { text: true, image: true, audio: true, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif',
            'audio/wav',
            'audio/mpeg',
            'audio/mp4',
            'audio/flac',
            'audio/ogg'
          ]
        }
      },
      {
        id: 'openai/gpt-4.1',
        name: 'OpenAI GPT-4.1',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-4.1-mini',
        name: 'OpenAI GPT-4.1 Mini',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-4.1-nano',
        name: 'OpenAI GPT-4.1 Nano',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-5.2',
        name: 'OpenAI GPT-5.2',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-5.2-chat',
        name: 'OpenAI GPT-5.2 Chat',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-5-mini',
        name: 'OpenAI GPT-5 Mini',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-5-nano',
        name: 'OpenAI GPT-5 Nano',
        enabled: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: true },
        outputModalities: { text: true, image: false, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: [
            'application/pdf',
            'text/plain',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/webp',
            'image/gif'
          ]
        }
      },
      {
        id: 'openai/gpt-image-1',
        name: 'OpenAI GPT Image 1',
        enabled: true,
        free: true,
        inputModalities: { text: true, image: true, audio: false, video: false, file: false },
        outputModalities: { text: false, image: true, audio: false, video: false },
        uploadSettings: {
          maxFiles: 1,
          maxFileSizeMB: 4,
          maxTotalFileSizeMB: 4,
          allowedExtensions: ['image/png', 'image/jpeg', 'image/webp']
        }
      },
      {
        id: 'openai/dall-e-3',
        name: 'OpenAI DALLΒ·E 3',
        enabled: true,
        inputModalities: { text: true, image: false, audio: false, video: false, file: false },
        outputModalities: { text: false, image: true, audio: false, video: false },
        uploadSettings: {
          maxFiles: 0,
          maxFileSizeMB: 0,
          maxTotalFileSizeMB: 0,
          allowedExtensions: []
        }
      },
      {
        id: 'openai/dall-e-2',
        name: 'OpenAI DALLΒ·E 2',
        enabled: false,
        inputModalities: { text: true, image: true, audio: false, video: false, file: false },
        outputModalities: { text: false, image: true, audio: false, video: false },
        uploadSettings: {
          maxFiles: 4,
          maxFileSizeMB: 10,
          maxTotalFileSizeMB: 15,
          allowedExtensions: ['image/png', 'image/jpeg', 'image/webp']
        }
      }
    ]
  }
]

export const AI_PURPOSES = [
  {
    id: 'chat',
    name: 'Chat/Conversation',
    modelType: 'text',
    defaultModel: 'arcee-ai/trinity-large-preview:free'
  },
  {
    id: 'character-description',
    name: 'Character Description',
    modelType: 'text',
    defaultModel: 'cognitivecomputations/dolphin-mistral-24b-venice-edition:free'
  },
  {
    id: 'campaign-hook',
    name: 'Campaign Hook',
    modelType: 'text',
    defaultModel: 'cognitivecomputations/dolphin-mistral-24b-venice-edition:free'
  },
  {
    id: 'character-sheet-import',
    name: 'Character Sheet Import',
    modelType: 'text',
    defaultModel: 'mistralai/mistral-small-3.1-24b-instruct:free'
  },
  {
    id: 'character-sheet-validate',
    name: 'Character Sheet Validate',
    modelType: 'text',
    defaultModel: 'mistralai/mistral-small-3.1-24b-instruct:free'
  },
  {
    id: 'general',
    name: 'General',
    modelType: 'text',
    defaultModel: 'x-ai/grok-4-fast'
  },
  { id: 'artwork', name: 'Art Work', modelType: 'image', defaultModel: 'openai/gpt-image-1' },
  { id: 'video-generation', name: 'Video Generation', modelType: 'video', defaultModel: '' }
]

export const AI_CHAT_RUNTIME_DEFAULTS = Object.freeze({
  defaultModel:
    AI_PURPOSES.find((purpose) => purpose.id === 'chat')?.defaultModel ||
    'arcee-ai/trinity-large-preview:free',
  fallbackModels: [
    'arcee-ai/trinity-large-preview:free',
    'arcee-ai/trinity-mini:free',
    'stepfun/step-3.5-flash:free'
  ],
  adminCanOverrideModel: true,
  freeOnlyFallbacks: true
})

export const AI_AGENT_SUBTASK_RUNTIME_DEFAULTS = Object.freeze({
  contextualizer: {
    defaultModel: 'arcee-ai/trinity-large-preview:free',
    fallbackModels: [
      'arcee-ai/trinity-mini:free',
      'stepfun/step-3.5-flash:free'
    ],
    purpose: 'agent-contextualizer',
    policy: {
      profile: 'fast_context_carry',
      goal: 'Preserve topic and rewrite short follow-ups into standalone user intent.',
      maxFallbacks: 1
    }
  },
  classifier: {
    defaultModel: 'arcee-ai/trinity-large-preview:free',
    fallbackModels: [
      'arcee-ai/trinity-mini:free',
      'stepfun/step-3.5-flash:free'
    ],
    purpose: 'agent-classifier',
    policy: {
      profile: 'fast_structured_routing',
      goal: 'Return reliable structured task specs with minimal latency.',
      maxFallbacks: 1
    }
  },
  planner: {
    defaultModel: '__CHAT_DEFAULT__',
    fallbackModels: [
      'arcee-ai/trinity-large-preview:free',
      'arcee-ai/trinity-mini:free',
      'stepfun/step-3.5-flash:free'
    ],
    purpose: 'agent-planner',
    policy: {
      profile: 'structured_reasoning',
      goal: 'Produce tool plans only when deterministic fallbacks cannot decide the next step.',
      maxFallbacks: 2
    }
  },
  draftCleanup: {
    defaultModel: '__CHAT_DEFAULT__',
    fallbackModels: [
      'arcee-ai/trinity-large-preview:free',
      'arcee-ai/trinity-mini:free',
      'stepfun/step-3.5-flash:free'
    ],
    purpose: 'agent-draft-cleanup',
    policy: {
      profile: 'cheap_grounded_rewriter',
      goal: 'Clean grounded drafts without changing facts or language unnecessarily.',
      maxFallbacks: 1
    }
  },
  jsonRepair: {
    defaultModel: 'stepfun/step-3.5-flash:free',
    fallbackModels: [
      'arcee-ai/trinity-mini:free',
      '__CHAT_DEFAULT__'
    ],
    purpose: 'agent-json-repair',
    policy: {
      profile: 'cheap_json_fixer',
      goal: 'Repair malformed structured outputs at the lowest reasonable cost.',
      maxFallbacks: 1
    }
  },
  synthesizer: {
    defaultModel: '__CHAT_DEFAULT__',
    fallbackModels: [
      'arcee-ai/trinity-large-preview:free',
      'arcee-ai/trinity-mini:free',
      'stepfun/step-3.5-flash:free'
    ],
    purpose: 'agent-synthesizer',
    policy: {
      profile: 'grounded_conversational_quality',
      goal: 'Produce fluent, in-character final replies from grounded evidence.',
      maxFallbacks: 2
    }
  },
  synthesizerLight: {
    defaultModel: 'arcee-ai/trinity-mini:free',
    fallbackModels: [
      'stepfun/step-3.5-flash:free',
      'arcee-ai/trinity-large-preview:free'
    ],
    purpose: 'agent-synthesizer-light',
    policy: {
      profile: 'cheap_conversational',
      goal: 'Produce brief in-character replies for simple chat and dice intents.',
      maxFallbacks: 1
    }
  }
})

// Returns purposes for which there is at least one enabled model of the required type for the given provider
export function getPurposes(providerId) {
  if (!providerId) return AI_PURPOSES
  const provider = AI_PROVIDERS.find((p) => p.id === providerId && p.enabled)
  if (!provider) return []
  const enabledTypes = new Set(
    provider.models
      .filter((m) => m.enabled)
      .flatMap((m) => Object.entries(m.outputModalities || {}))
      .filter(([, v]) => !!v)
      .map(([k]) => k)
  )
  return AI_PURPOSES.filter((purpose) => enabledTypes.has(purpose.modelType))
}

// --- Defaults helpers (for consumers like composables/_shared) ---
export function getDefaultTextProviderId() {
  // 1) explicit flag, 2) known id 'openrouter', 3) any enabled provider with text models, 4) first enabled
  const flagged = AI_PROVIDERS.find((p) => p.enabled && p.isDefaultTextProvider)
  if (flagged) return flagged.id
  const openrouter = AI_PROVIDERS.find((p) => p.enabled && p.id === 'openrouter')
  if (openrouter) return openrouter.id
  const withText = AI_PROVIDERS.find(
    (p) => p.enabled && p.models.some((m) => m.enabled && m.outputModalities?.text)
  )
  if (withText) return withText.id
  const any = AI_PROVIDERS.find((p) => p.enabled)
  return any ? any.id : undefined
}

export function getDefaultImageProviderId() {
  // 1) explicit flag, 2) known id 'openai', 3) any enabled provider with image models, 4) first enabled
  const flagged = AI_PROVIDERS.find((p) => p.enabled && p.isDefaultImageProvider)
  if (flagged) return flagged.id
  const openai = AI_PROVIDERS.find((p) => p.enabled && p.id === 'openai')
  if (openai) return openai.id
  const withImage = AI_PROVIDERS.find(
    (p) => p.enabled && p.models.some((m) => m.enabled && m.outputModalities?.image)
  )
  if (withImage) return withImage.id
  const any = AI_PROVIDERS.find((p) => p.enabled)
  return any ? any.id : undefined
}

export function getDefaultTextModelId(providerId) {
  const provider = AI_PROVIDERS.find((p) => p.id === providerId && p.enabled)
  if (!provider) return undefined
  const models = provider.models.filter((m) => m.enabled && m.outputModalities?.text)
  // Prefer any model marked as default for this provider
  const marked = models.find((m) => m.isDefault || m.default)
  if (marked) return marked.id
  // Prefer a free text model when available
  const free = models.find((m) => m.free)
  if (free) return free.id
  // Fallback to the first enabled text model for this provider
  return models.length ? models[0].id : undefined
}

export function getDefaultImageModelId(providerId) {
  const provider = AI_PROVIDERS.find((p) => p.id === providerId && p.enabled)
  if (!provider) return undefined
  const models = provider.models.filter((m) => m.enabled && m.outputModalities?.image)
  // Maintain current functionality: prefer GPT-Image-1 when available
  const preferredId = 'openai/gpt-image-1'
  const preferred = models.find((m) => m.id === preferredId)
  if (preferred) return preferred.id
  const marked = models.find((m) => m.isDefault)
  if (marked) return marked.id
  return models.length ? models[0].id : undefined
}

export function getModelsByProvider(providerId, type) {
  const provider = AI_PROVIDERS.find((p) => p.id === providerId && p.enabled)
  if (!provider) return []
  const enabledModels = provider.models.filter((m) => m.enabled)
  if (!type) return enabledModels
  return enabledModels.filter((m) => {
    const out = m.outputModalities || {}
    if (type === 'text') return !!out.text
    if (type === 'image') return !!out.image
    if (type === 'video') return !!out.video
    if (type === 'audio') return !!out.audio
    return false
  })
}

// Export a helper to get purpose-level default model id.
export function getPurposeDefaultModelId(purposeId) {
  const p = AI_PURPOSES.find((x) => x.id === purposeId)
  return p?.defaultModel
}
